import { useFlightSearchResults } from '@pages/FlightSearchResult/contexts/FlightSearchResultsContext';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getTranslationsState } from '@redux/selectors';

import styles from './HajjSeasonNotice.module.scss';

export const HAJJ_ARRIVAL_CITY_CODES = ['JED', 'MED'];
export const SAUDI_ARABIA_COUNTRY_CODE = 'SA';

const HajjSeasonNotice: React.FC = () => {
  const translations = useSelector(getTranslationsState);

  const { search } = useFlightSearchResults();

  const isOriginNotSA = useMemo(() => {
    const departureCountryCodes = search?.legs.map((leg) => leg.departureCity.countryCode) || [];

    return !departureCountryCodes.every((countryCode) => countryCode === SAUDI_ARABIA_COUNTRY_CODE);
  }, [search?.legs]);

  const isArrivalInHajj = useMemo(() => {
    const arrivalCityCodes = search?.legs.map((leg) => leg.arrivalCity.code) || [];

    return arrivalCityCodes.some((code) => HAJJ_ARRIVAL_CITY_CODES.includes(code));
  }, [search?.legs]);

  return isOriginNotSA && isArrivalInHajj ? (
    <div id='hajj-season-notice' className={styles.hajjSeasonNotice}>
      {translations.hajj_season_notice}
    </div>
  ) : null;
};

export default HajjSeasonNotice;
